import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from './auth.service';
import { Router} from '@angular/router';
import { InterviewdetailService } from '../../interviewdetail/interviewdetail.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

 public username;
 public password;

public errormsg='';

 logindetails: any = {};



  constructor(private _router: Router, private service : AuthService ,private interviewdetail_service :InterviewdetailService) { }

  ngOnInit() {

  

        }
      login(form: NgForm)
      {
 
           this.username=form.value.email;   
            this.password=form.value.password;
          
            this.service.getLoginData(this.username,this.password)
           .subscribe(
             (data: any) =>{
               console.log(data);
               this.logindetails = data
               console.log( this.logindetails);
             

       })


         
          
      
    }



    }



// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/auth/login/login.component.ts